export default __webpack_public_path__ + "static/media/manuel-montali-2.872c3520.webp";